import { axiosServiceNowApi } from 'services/Api'
import { Dispatch } from 'redux'
import { AxiosResponse, AxiosError } from 'axios'
import {
    SectorAction,
    Sector,
    ResultSectorGetAllPaginate,
    ResultSectorGetCount,
    ResultSectorGetById
} from 'types/sector'
import { ROUTES_NAMES } from 'constants/servicenow.routes'
import { REDUX } from 'constants/'
import store from 'store'

const SectorActions = {
    setSectors: (dispatch: Dispatch<SectorAction>, sectors: any[]) => {
        dispatch({
            type: REDUX.reducers.GET_ALL_SECTORS,
            payload: sectors
        } as SectorAction)

        return null
    },
    /**
     * Executa dois webservices no serviceNow, ws para lista paginada de setores e ws para contagem de todos os setores
     * @param dispatch dispatch padrão para action setor
     * @param offset numero atual da pagina solicitada
     * @param limit limite de itens por página
     */
    getAllSectors: async (dispatch: Dispatch<SectorAction>) => {
        let sectorsList = store?.getState()?.sectorReducers.sectorsList
        if (sectorsList.length === 0) {
            const responseSectorList: Promise<
                AxiosResponse<ResultSectorGetAllPaginate>
            > = axiosServiceNowApi?.get(ROUTES_NAMES.sector.get.all)
            await responseSectorList
                .then(
                    (
                        promisseResponse: AxiosResponse<ResultSectorGetAllPaginate>
                    ) => {
                        dispatch({
                            type: REDUX.reducers.GET_ALL_SECTORS,
                            payload: promisseResponse.data.result
                        } as SectorAction)
                    }
                )
                .catch((error: AxiosError) => {
                    dispatch({
                        type: REDUX.reducers.ERROR_SECTORS,
                        payload: error.message
                    } as SectorAction)
                })
                .finally(() => {})
        }
        return ROUTES_NAMES.sector.get.all
    },
    /**
     * Executa dois webservices no serviceNow, ws para lista paginada de setores e ws para contagem de todos os setores
     * @param dispatch dispatch padrão para action setor
     * @param offset numero atual da pagina solicitada
     * @param limit limite de itens por página
     */
    getAllSectorsPaginate: async (
        dispatch: Dispatch<SectorAction>,
        offset?: string,
        limit?: string,
        order?: any,
        search?: string,
        locationId?: string
    ) => {
        dispatch({
            type: REDUX.reducers.GET_ALL_SECTORS_COUNT_LOADING
        } as SectorAction)
        const responseSectorList: Promise<
            AxiosResponse<ResultSectorGetAllPaginate>
        > = axiosServiceNowApi?.get(
            ROUTES_NAMES.sector.get.all_paginate(
                offset,
                limit,
                order,
                search,
                locationId
            )
        )
        await Promise.all([responseSectorList])
            .then((promisseResponse: [AxiosResponse<any>]) => {
                dispatch({
                    type: REDUX.reducers.GET_ALL_SECTORS_COUNT,
                    payload: promisseResponse[0].data?.stats?.count
                } as SectorAction)
                dispatch({
                    type: REDUX.reducers.GET_ALL_SECTORS,
                    payload: promisseResponse[0].data?.result
                } as SectorAction)
            })
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_SECTORS,
                    payload: error.message
                } as SectorAction)
            })
            .finally(() => {})

        return ROUTES_NAMES.sector.get.all_paginate(offset, limit)
    },
    createNewSector: (dispatch: Dispatch<SectorAction>, newSector: Sector) => {
        dispatch({
            type: REDUX.reducers.GET_LOADING
        } as SectorAction)
        dispatch({
            type: REDUX.reducers.ADD_NEW_SECTOR,
            payload: newSector
        } as SectorAction)
        return true
    },
    updateSector: (dispatch: Dispatch<SectorAction>, updatedSector: Sector) => {
        dispatch({
            type: REDUX.reducers.UPDATE_SECTOR,
            payload: updatedSector
        } as SectorAction)
        return true
    },
    getSectorById: async (dispatch: Dispatch<SectorAction>, id: string) => {
        const response: Promise<AxiosResponse<ResultSectorGetById>> =
            axiosServiceNowApi?.get(ROUTES_NAMES.sector.get.byid(id))
        await response
            .then((res: AxiosResponse<ResultSectorGetById>) => {
                dispatch({
                    type: REDUX.reducers.GET_CURRENT_SECTOR,
                    payload: res.data.result[0]
                } as SectorAction)
            })
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_SECTORS,
                    payload: error
                } as SectorAction)
            })
            .finally(() => {})
        return ROUTES_NAMES.sector.get.byid(id)
    },
    getAllSectorsByLocationId: async (
        dispatch: Dispatch<SectorAction>,
        locationId: string,
        search?: string,
        status?: string,
        order?: any
    ) => {
        const responseSectorList: Promise<
            AxiosResponse<ResultSectorGetAllPaginate>
        > = axiosServiceNowApi?.get(
            ROUTES_NAMES.sector.get.by_locationid(locationId, search, status, order)
        )
        await responseSectorList
            .then((promisseResponse: AxiosResponse<any>) => {
                const mappedSectors = promisseResponse.data.result.map((sector) => ({
                    sys_id: sector.sys_id.value,
                    u_name: sector.u_name.value,
                    u_active: sector.u_active.value
                }))
                
                dispatch({
                    type: REDUX.reducers.GET_ALL_SECTORS,
                    payload: mappedSectors
                } as SectorAction)
            })
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_SECTORS,
                    payload: error.message
                } as SectorAction)
            })
            .finally(() => {})

        return ROUTES_NAMES.sector.get.by_locationid(locationId, search, status, order)
    },
    getAllSectorsGroupedByLocationsId: async (
        dispatch: Dispatch<SectorAction>
    ) => {
        const responseSectorList: Promise<
            AxiosResponse<ResultSectorGetAllPaginate>
        > = axiosServiceNowApi?.get(
            ROUTES_NAMES.sector.get.grouped_by_locationid()
        )
        let sectorsGroupedByLocationId =
            store?.getState()?.sectorReducers.sectorsGroupedByLocationId

        if (JSON.stringify(sectorsGroupedByLocationId) === `{}`) {
            await responseSectorList
                .then((promisseResponse: AxiosResponse<any>) => {
                    dispatch({
                        type: REDUX.reducers
                            .GET_ALL_SECTORS_GROUPED_BY_LOCATION,
                        payload: promisseResponse?.data
                    } as SectorAction)
                })
                .catch((error: AxiosError) => {
                    dispatch({
                        type: REDUX.reducers.ERROR_SECTORS,
                        payload: error?.message
                    } as SectorAction)
                })
                .finally(() => {})
        }
        return ROUTES_NAMES.sector.get.grouped_by_locationid()
    },
    clearAllSectors: (dispatch: Dispatch<SectorAction>) => {
        dispatch({
            type: REDUX.reducers.GET_ALL_SECTORS,
            payload: []
        } as SectorAction)
    }
}

export default SectorActions
